import React from 'react';
import {
    DmsButton,
    intl
} from "dmsbasereact";
import {
    Box,
    Grid,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    CircularProgress,
} from '@mui/material';
import { useReturnForm } from '../DmsReturnModal/useReturnForm';
import { ReturnReasonContainer } from '../DmsReturnModal/sections/ReturnReasonContainer';
import { TreatmentDiscontinuationContainer } from '../DmsReturnModal/sections/TreatmentDiscontinuationContainer';
import { QualityReasonContainer } from '../DmsReturnModal/sections/QualityReasonContainer';
import { OrderDivergenceFullContainer } from '../DmsReturnModal/sections/OrderDivergenceFullContainer';
import { RETURN_REASON_KEYS } from '../../constants/ReturnReasons';
import { useReturnReasonOptions } from '../../constants/ReturnReasons';
import { useQualityIssueOptions } from '../../constants/QualityIssues';
import { useTreatmentDiscontinuationOptions } from '../../constants/TreatmentDiscontinuationEnum';


export const DmsReturnEditModal = ({ show, onHide, row, table, managementMode = false }) => {
    const { state, handlers } = useReturnForm({ row, table, onHide, show, managementMode });
    const {
        data,
        selectedReason,
        isLoading,
        checkSubmitted,
        files,
        existingFiles,
        searchedDispensings,
        dispensings,
        batches,
        returnReasons,
        institutionOptions,
    } = state;
    const {
        handleSave,
        handleChange,
        handleReturnReasonChange,
        handleInstitutionChange,
        handleFileSelect,
        setSearchedDispensings,
        fieldHasError,
        helperText,
        handleCheckoutDataChange,
        handleCheckoutSubmitted,
    } = handlers;
    
    const QualityIssueOptions = useQualityIssueOptions();
    const ReturnReasonOptions = useReturnReasonOptions();
    const TreatmentDiscontinuationOptions = useTreatmentDiscontinuationOptions();
    
    return (
        <>
            <Dialog open={show} onClose={onHide} fullWidth maxWidth="md">
                <DialogTitle>
                    {intl.get("EditReturn").d("Edit Return")}
                </DialogTitle>
                <DialogContent>
                    {isLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box sx={{ mt: 2 }}>
                            <Grid container spacing={2}>
                                <ReturnReasonContainer
                                    data={data}
                                    handleChange={handleChange}
                                    handleReturnReasonChange={handleReturnReasonChange}
                                    handleInstitutionChange={handleInstitutionChange}
                                    ReturnReasonOptions={ReturnReasonOptions}
                                    returnReasons={returnReasons}
                                    selectedReason={selectedReason}
                                    fieldHasError={fieldHasError}
                                    helperText={helperText}
                                    TreatmentDiscontinuationOptions={TreatmentDiscontinuationOptions}
                                    QualityIssueOptions={QualityIssueOptions}
                                    intl={intl}
                                    checkSubmitted={checkSubmitted}
                                    institutionOptions={institutionOptions}
                                    managementMode={managementMode}
                                />

                                {selectedReason?.name === RETURN_REASON_KEYS.TREATMENT_DISCONTINUATION &&
                                    <TreatmentDiscontinuationContainer
                                        searchedDispensings={searchedDispensings}
                                        setSearchedDispensings={setSearchedDispensings}
                                        dispensings={dispensings}
                                        data={data}
                                        handleChange={handleChange}
                                        fieldHasError={fieldHasError}
                                        helperText={helperText}
                                        intl={intl}
                                        batches={batches}
                                    />
                                }

                                {selectedReason?.name === RETURN_REASON_KEYS.QUALITY_ISSUE &&
                                    <QualityReasonContainer
                                        files={files}
                                        handleFileSelect={handleFileSelect}
                                        existingFiles={existingFiles}
                                        data={data}
                                        handleChange={handleChange}
                                        fieldHasError={fieldHasError}
                                        helperText={helperText}
                                        intl={intl}
                                        searchedDispensings={searchedDispensings}
                                        setSearchedDispensings={setSearchedDispensings}
                                        dispensings={dispensings}
                                    />
                                }

                                {selectedReason?.name === RETURN_REASON_KEYS.ORDER_DIVERGENCE &&
                                    <OrderDivergenceFullContainer
                                        organizationBranches={state.organizationBranches}
                                        batches={batches}
                                        handleCheckoutDataChange={handleCheckoutDataChange}
                                        handleCheckoutSubmitted={handleCheckoutSubmitted}
                                        checkoutData={state.checkoutData}
                                        files={files}
                                        handleFileSelect={handleFileSelect}
                                        existingFiles={existingFiles}
                                        data={data}
                                        handleChange={handleChange}
                                        fieldHasError={fieldHasError}
                                        helperText={helperText}
                                        intl={intl}
                                    />
                                }
                            </Grid>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <DmsButton
                        onClick={onHide}
                        text={intl.get("Cancel").d("Cancel")}
                        disabled={isLoading}
                    />
                    <DmsButton
                        onClick={handleSave}
                        variant="primary"
                        text={intl.get("Save").d("Save")}
                        disabled={isLoading}
                    />
                </DialogActions>
            </Dialog>
        </>
    );
};